import { postUserLogin, getUserInfo, getSSOConfiguration, getEnvironment, saveUser, postSaveDataOptOut,
  updatePassword, populateUserJwt, resetPassword, verifyUser, learnerSelfRegistration, verifySelfRegistration,
  getAllUserInstitution, getChangeUserInstitution } from '../api'
import { setItem } from '../../../storage'

export const loadUserLogin = ({ state, commit }, userInfo) => {
  return postUserLogin(userInfo).then((response) => {
    let userObj = response.data
    if (userObj) {
      setItem('token', userObj.password)
      setItem('loginTime', new Date())
      commit('LOAD_CURRENT_USER', userObj)

      // Create DB
      /*
      (new Sqlite("my.db")).then(db => {
          db.execSQL("CREATE TABLE IF NOT EXISTS users (id INTEGER PRIMARY KEY AUTOINCREMENT, token TEXT)").then(id => {
            // any additional processing
          }, error => {
              console.log("CREATE TABLE ERROR", error)
          })

          db.execSQL("INSERT INTO users (token) VALUES (?, ?)", [userObj.password]).then(id => {
            // any additional processing
          }, error => {
              console.log("INSERT ERROR", error);
          })

          // Put the DB in vuex
          commit('LOAD_DB', db)
      }, error => {
          console.log("OPEN DB ERROR", error)
      })
      */
    }
    return response
  })
}

export const loadToken = ({ state, commit }, token) => {
  setItem('token', token)
}

export const loadUserObj = ({ state, commit }) => {
  return getUserInfo().then((userObj) => {
    if (userObj) {
      setItem('token', userObj.password)
      setItem('loginTime', new Date())
      commit('LOAD_CURRENT_USER', userObj)
      return userObj
    }
  })
}

export const loadUpdateUserObj = ({ state, commit }, userObj) => {
    commit('LOAD_CURRENT_USER', userObj)
    return userObj
}

export const loadSSOConfiguration = ({ state, commit }) => {
  return getSSOConfiguration()
}

export const loadEnvironment = ({ state, commit }) => {
  return getEnvironment()
}

export const loadSaveUser = ({ state, commit }, {uuid, user}) => {
  return saveUser(uuid, user)
}

export const loadSaveDataOptOut = ({ state, commit }, formData) => {
  return postSaveDataOptOut(formData)
}

export const loadUpdatePassword = ({ state, commit }, {data}) => {
  return updatePassword(data)
}

export const loadUserJwt = ({ state, commit }) => {
  return populateUserJwt('{}').then(data => {
    return data.jwt
  })
}

export const loadResetPassword = ({ state, commit }, email) => {
  return resetPassword(email)
}

export const loadVerifyUser = ({ state, commit }, data) => {
  return verifyUser(data).then(response => {
    let userObj = response.data
    if (userObj) {
      setItem('token', userObj.password)
      setItem('loginTime', new Date())
      commit('LOAD_CURRENT_USER', userObj)
    }
    return response
  })
}

export const setTemporaryUser = ({ state, commit }) => {
  setItem('tempUser', true)
  commit('LOAD_TEMP_USER_FLAG', true)
}

export const loadLearnerSelfRegistration = ({ state, commit }, { orgId, user }) => {
  return learnerSelfRegistration(orgId, user).then(response => {
    let userObj = response.data
    if (userObj) {
      setItem('token', userObj.password)
      setItem('loginTime', new Date())
      commit('LOAD_CURRENT_USER', userObj)
    }
    return response
  })
}

export const loadVerifySelfRegistration = ({ state, commit }, data) => {
  return verifySelfRegistration(data).then(response => {
    let userObj = response.data
    if (userObj) {
      setItem('token', userObj.password)
      setItem('loginTime', new Date())
      commit('LOAD_CURRENT_USER', userObj)
    }
    return response
  })
}

export const loadAllUserInstitution = ({ state, commit }) => {
  return getAllUserInstitution()
}

export const loadChangeUserInstitution = ({ state, commit }, institutionId) => {
  return getChangeUserInstitution(institutionId).then(response => {
    let userObj = response.data
    if (userObj) {
      setItem('token', userObj.password)
      setItem('loginTime', new Date())
      commit('LOAD_CURRENT_USER', userObj)
    }
    return response
  })
}



// WEBPACK FOOTER //
// ./src/app/login/vuex/actions.js